import { axiosServices } from "./axiosServices";

export const notificationServices = { getNotificationList, clearNotificationList };

function getNotificationList(param) {
    return axiosServices.getAxios(`/v1/common/sub/notifications${param}`).then(
        res => {
            return res;
        });
}

function clearNotificationList(bodyData) {
    return axiosServices.deleteAxios('/v1/common/sub/notifications', bodyData).then(
        res => {
            return res;
        });
}